import { render, staticRenderFns } from "./UnitCost.vue?vue&type=template&id=c1d3996a&"
import script from "./UnitCost.vue?vue&type=script&lang=js&"
export * from "./UnitCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports